<template>
 <customModal :containermd="true" :bodymd="true" @closeModal="closeAssignModal()" >
    <template #title>
      {{ $t("navigations.forms") }}
    </template>
    <template #body>
        <table class="table features-table">
        <p v-if="ecrfformlist == ''" class="mb-0 text-center">
          {{ $t("navigations.no forms added") }}
        </p>
        <tbody>
          <tr v-for="forms in ecrfformlist" :key="forms.id">
            <td>{{ forms.templateName }} ({{ forms.version }})</td>
            <td class="d-flex align-items-start" style="gap: 1rem">
              <div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :id="'selectDate-' + forms.id"
                    v-model="forms.useDate"
                    :checked="forms.useDate"
                    @change="
                      forms.useRecurrence = false;
                      if (!forms.useDate) {
                        forms.selectedDate = '';
                      }
                    "
                  />
                  <label
                    class="form-check-label"
                    :for="'selectDate-' + forms.id"
                  >
                    Select Date
                  </label>
                </div>
                <div v-if="forms.useDate" class="mb-0">
                  <input
                    type="date"
                    v-model="forms.selectedDate"
                    class="form-control"
                  />
                  <div
                    v-if="forms.useDate && !forms.selectedDate"
                    class="text-danger mb-2"
                    style="font-size: 12px"
                  >
                    Please select a date.
                  </div>
                </div>
              </div>
              <div>
                <div class="form-check mb-0">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :id="'selectRecurrence-' + forms.id"
                    v-model="forms.useRecurrence"
                    :checked="forms.useRecurrence"
                    @change="
                      forms.useDate = false;
                      if (!forms.useRecurrence) {
                        forms.selectedRecurrence = '';
                        forms.recurrenceFromDate = '';
                        forms.occurrence = '';
                      }
                    "
                  />
                  <label
                    class="form-check-label"
                    :for="'selectRecurrence-' + forms.id"
                  >
                    Recurrence Cycle
                  </label>
                </div>
                <div v-if="forms.useRecurrence">
                  <select
                    v-model="forms.selectedRecurrence"
                    class="form-control mt-2"
                  >
                    <option disabled value="">Select cycle</option>
                    <option value="daily">Daily</option>
                    <option value="weekly">Weekly</option>
                    <option value="monthly">Monthly</option>
                  </select>
                  <div
                    v-if="
                      forms.useRecurrence && !forms.selectedRecurrence
                    "
                    class="text-danger mb-2"
                    style="font-size: 12px"
                  >
                    Please select a recurrence cycle.
                  </div>
                  <input
                    type="date"
                    v-model="forms.recurrenceFromDate"
                    class="form-control mt-2"
                    placeholder="From Date"
                  />
                  <div
                    v-if="
                      forms.useRecurrence && !forms.recurrenceFromDate
                    "
                    class="text-danger mb-2"
                    style="font-size: 12px"
                  >
                    Please select a start date.
                  </div>
                  <input
                    type="number"
                    v-model.number="forms.occurrence"
                    class="form-control"
                    min="1"
                    step="1"
                    placeholder="Occurrence"
                  />
                  <div
                    v-if="
                      forms.useRecurrence &&
                      (!forms.occurrence || forms.occurrence < 1)
                    "
                    class="text-danger mt-0"
                    style="font-size: 12px"
                  >
                    Please enter a valid whole number (min 1).
                  </div>
                </div>
              </div>
            </td>
            <td class="text-center">
              <button
                class="btn btn-primary btn-sm py-0"
                @click="saveForm(forms)"
              >
                Save
              </button>
            </td>
            <td></td>
          </tr>
        </tbody>
        </table>
    </template>
 </customModal>
</template>
<script src="./AssignEproPopup.js"> </script>
<style scoped>
</style>